module.exports = __webpack_public_path__ + "media/theme/sample__mobage-31cd5781.png";